import React from "react";

// ✅ Lazy loading (important)
const Home = React.lazy(() => import("../Components/Home"));
const Login = React.lazy(() => import("../Components/Login"));
const Signup = React.lazy(() => import("../Components/Signup"));
const GoogleCompleteRegistration = React.lazy(() => import("../Components/GoogleCompleteRegistration"));
const Otpverification = React.lazy(() => import("../Components/Signup/Otpverification"));
const Forgetpassword = React.lazy(() => import("../Components/Login/Forgetpassword"));
const EmpDashboard = React.lazy(() => import("../Components/EmpDashboard"));
const Membership = React.lazy(() => import("../Components/Membership"));
const Profile = React.lazy(() => import("../CommonViews/Profile"));
const FreelancerProfileRoute = React.lazy(() => import("../CommonViews/Profile/FreelancerProfileRoute"));
const FreelancerReport = React.lazy(() => import("../CommonViews/Profile/FreelancerReport"));
const FreelancerDashboard = React.lazy(() => import("../Components/FreelancerDashboard"));
const SingleCat = React.lazy(() => import("../Views/SingleCat"));
const UpdateProfile = React.lazy(() => import("../CommonViews/Profile/Update_profile"));
const CreateProject = React.lazy(() => import("../Components/FreelancerDashboard/CreateProject"));
const ShowcaseView = React.lazy(() => import("../Components/FreelancerDashboard/ShowcaseView"));
const PortfolioUpdate = React.lazy(() => import("../CommonViews/Profile/PortFolioUpdate"));
const FinancialDashboard = React.lazy(() => import("../Components/FreelancerDashboard/FinancialDashboard"));
const UserSettings = React.lazy(() => import("../CommonViews/UserSettings"));

const PostProject = React.lazy(() => import("../Components/EmpDashboard/PostProject"));
const PostProjectAssistant = React.lazy(() => import("../Components/EmpDashboard/PostProjectAssistant"));
const FindJobs = React.lazy(() => import("../Components/FindJobs"));
const JobDetails = React.lazy(() => import("../Components/FindJobs/JobDetails"));
const Showcase = React.lazy(() => import("../Components/Showcase"));
const AboutUs = React.lazy(() => import("../Components/AboutUs"));
const HowItWorks = React.lazy(() => import("../Components/HowItWorks"));
const Support = React.lazy(() => import("../Components/Support"));
const CodeConduct = React.lazy(() => import("../Components/CodeConduct"));
const CopyRightPolicy = React.lazy(() => import("../Components/CopyRightPolicy"));
const TermsAndCondition = React.lazy(() => import("../Components/TermsAndCondition"));
const PrivacyPolicy = React.lazy(() => import("../Components/PrivacyPolicy"));
const Paypal = React.lazy(() => import("../Components/Paypal"));

const OpenRequest = React.lazy(() => import("../CommonViews/CustomerSupport/OpenRequest"));
const NewRequestCS = React.lazy(() => import("../CommonViews/CustomerSupport/NewRequestCS"));
const ReplyTicket = React.lazy(() => import("../CommonViews/CustomerSupport/ReplyTicket"));

const ProjectProposals = React.lazy(() => import("../Components/EmpDashboard/PorjectProposals"));
const ProjectJobDetails = React.lazy(() => import("../Components/EmpDashboard/ProjectJobDetails"));
const Proposals = React.lazy(() => import("../Components/FreelancerDashboard/Proposals"));
const ViewProfile = React.lazy(() => import("../CommonViews/ViewProfile"));
const FindFreelancers = React.lazy(() => import("../Components/EmpDashboard/FindFreelancers"));
const Messages = React.lazy(() => import("../CommonViews/Messages"));
const ShowcaseClient = React.lazy(() => import("../Components/EmpDashboard/ShowcaseClient"));
const ShowcaseProjects = React.lazy(() => import("../Components/EmpDashboard/ShowcaseClient/ShowcaseProjects"));
const MyProjects = React.lazy(() => import("../Components/EmpDashboard/MyProjects"));
const SingleShowcase = React.lazy(() => import("../Components/EmpDashboard/ShowcaseClient/SingleShowcase"));
const Referral = React.lazy(() => import("../Components/Referral"));
const ShowcaseCheckout = React.lazy(() => import("../Components/EmpDashboard/ShowcaseCheckout"));
const MyShowcase = React.lazy(() => import("../Components/FreelancerDashboard/MyShowcase"));
const Hired = React.lazy(() => import("../CommonViews/Hired"));
const MyActiveOrders = React.lazy(() => import("../Components/FreelancerDashboard/MyActiveOrders"));
const SingleShowcaseView = React.lazy(() => import("../CommonViews/SingleShowcaseView"));
const DisputeFlow = React.lazy(() => import("../CommonViews/DisputeFlow"));
const CreateDispute = React.lazy(() => import("../CommonViews/DisputeFlow/CreateDispute"));
const Addon = React.lazy(() => import("../Components/EmpDashboard/PorjectProposals/Addon"));
const AwardedFreelancer = React.lazy(() => import("../Components/EmpDashboard/PorjectProposals/AwardedFreelancer"));
const SupportHelp = React.lazy(() => import("../Components/Support/SupportHelp"));
const ExamList = React.lazy(() => import("../CommonViews/Certifications/ExamsList"));
const ExamView = React.lazy(() => import("../CommonViews/Certifications/ExamView"));

const Myhire = React.lazy(() => import("../Components/EmpDashboard/Myhire"));
const Searching = React.lazy(() => import("../CommonViews/Searching"));
const TransactionHistory = React.lazy(() => import("../Components/TransactionHistory"));
const WithdrawFunds = React.lazy(() => import("../Components/WithdrawFund"));
const ActiveProjectsData = React.lazy(() => import("../Components/EmpDashboard/MyProjects/ActiveProjects2"));
const PaymentVerification = React.lazy(() => import("../CommonViews/PaymentVerification"));
const Invoice = React.lazy(() => import("../CommonViews/Invoice"));
const PayBalance = React.lazy(() => import("../Components/Paypal/PayBalance"));

const MyAnalystics = React.lazy(() => import("../Components/FreelancerDashboard/Analytics/MyAnalystics"));
const SupportType = React.lazy(() => import("../Components/Support/SupportType"));
const ShowcaseDetails = React.lazy(() => import("../Components/Showcase/ShowcaseDetails"));
const ShowcaseData = React.lazy(() => import("../CommonViews/SingleShowcaseView/ShowcaseData"));
const ShowReviews = React.lazy(() => import("../CommonViews/SingleShowcaseView/ShowReviews"));
const SinglePortfolio = React.lazy(() => import("../CommonViews/Profile/PortFolioUpdate/SinglePortfolio"));
const ChatDetails = React.lazy(() => import("../CommonViews/Messages/ChatDetails"));
const Addmembers = React.lazy(() => import("../CommonViews/Messages/Addmembers"));
const HourlyTracker = React.lazy(() => import("../CommonViews/HourlyTracker"));


export const freeRoutes = [
    {
        "name": "/",
        "component": <Home />
    },

    {
        "name": "/addfunds",
        "component": <Paypal />
    },

    {
        "name": "/login",
        "component": <Login />
    },
    {
        "name": "/signup",
        "component": <Signup />
    },
    {
        "name": "/complete-google-registration",
        "component": <GoogleCompleteRegistration />
    },
    {
        "name": "/verify-otp",
        "component": <Otpverification />
    },
    {
        "name": "/forget_password",
        "component": <Forgetpassword />
    },
    {
        "name": "/membership",
        "component": <Membership />
    },
    {
        "name": "/single-category/:slug",
        "component": <SingleCat />
    },
    // {
    //     "name": "/hire_freelancer",
    //     "component": <HireFreelancer />
    // },

    // {
    //     "name": "/show_showcase",
    //     "component": <Showcase />
    // },
    {
        "name": "/about_us",
        "component": <AboutUs />

    },
    {
        "name": "/how_it_works",
        "component": <HowItWorks />

    },
    {
        "name": "/support",
        "component": <Support />

    },
    {
        "name": "/support-help/:id",
        "component": <SupportHelp />
    },
    {
        "name": "/support-help/:id/:name",
        "component": <SupportType />
    },

    {
        "name": "/code_of_conduct",
        "component": <CodeConduct />
    },
    {
        "name": "/copy_right_policy",
        "component": <CopyRightPolicy />

    },
    {
        "name": "/terms_and_condition",
        "component": <TermsAndCondition />

    },
    {
        "name": "/privacy_policy",
        "component": <PrivacyPolicy />
    },

    {
        "name": "/search-projects-freelancer",
        "component": <FindJobs />
    },

    {
        "name": "/referral",
        "component": <Referral />
    },
    {
        "name": "/showcase-projects",
        "component": <ShowcaseClient />
    },
    {
        "name": "/showcase-projects/:id",
        "component": <ShowcaseProjects />
    },
    // {
    //     "name": "/find-showcase",
    //     "component": <ShowcaseClient />
    // },
    {
        "name": "/find-freelancers",
        "component": <FindFreelancers />
    },
    {
        "name": "/showcase",
        "component": <Searching />
    },
];

export const empRoutes = [
    {
        "name": "/dashboard",
        "component": <EmpDashboard />
    },

    {
        "name": "/post-project",
        "component": <PostProject />
    },
    {
        "name": "/post-project-assistant",
        "component": <PostProjectAssistant />
    },
    {
        "name": "/project-proposals/:id",
        "component": <ProjectProposals />
    },
    {
        "name": "/report-freelancer/:name",
        "component": <FreelancerReport />
    },
    {
        "name": "/project-job-details/:id",
        "component": <ProjectJobDetails />
    },
    {
        "name": "/project-addons/:id",
        "component": <Addon />
    },
    {
        "name": "/project-payments/:id",
        "component": <Hired />
    },
    {
        "name": "/project-hourly/:id",
        "component": <HourlyTracker />
    },
    // {
    //     "name": "/showcase-projects/:id",
    //     "component": <ShowcaseProjects />
    // },
    {
        "name": "/showcase-view/:id",
        // "component": <SingleShowcaseView />
        "component": <SingleShowcase />
    },
    {
        "name": "/my-projects",
        "component": <MyProjects />
    },
    {
        "name": "/showcase-checkout",
        "component": <ShowcaseCheckout />
    },
    {
        "name": "/awarded-freelancer/:id",
        "component": <AwardedFreelancer />
    },
    {
        "name": "/client-profile/:username",
        "component": <Profile />
    },
    // {
    //     "name": "/pay-balance",
    //     "component": <PayBalance />
    // }

];

export const lancerRoutes = [
    {
        "name": "/freelancer-dashboard",
        "component": <FreelancerDashboard />
    },

    {
        "name": "/add-showcase",
        "component": <CreateProject />
    },
    {
        "name": "/showcase",
        "component": <ShowcaseView />
    },

    {
        "name": "/my-proposals",
        "component": <Proposals />
    },
    {
        "name": "/job-details/:id",
        "component": <JobDetails />
    },
    {
        "name": "/job-proposals/:id",
        "component": <JobDetails />
    },
    {
        "name": "/job-payments/:id",
        "component": <Hired />
    },
    {
        "name": "/job-hourly/:id",
        "component": <HourlyTracker />
    },
    {
        "name": "my-showcases",
        "component": <MyShowcase />
    },
    {
        "name": "my-active-orders",
        "component": <MyActiveOrders />
    },

    {
        "name": "my-showcase-preview/:id",
        "component": <SingleShowcase />
        // "component": <SingleShowcaseView />
    },
    {
        "name": "/payment-freelancer",
        "component": <PaymentVerification />
    },
    {
        "name": "/view-details",
        "component": <Invoice />
    },
    {
        "name": "/my-analytics",
        "component": <MyAnalystics />
    },
    {
        "name": "/get-certifications",
        "component": <ExamList />
    },
    {
        "name": "/view-profolio/:id",
        "component": <SinglePortfolio />
    }


];

export const commonRoutes = [
    {
        "name": "/freelancer-profile/:username",
        "component": <FreelancerProfileRoute />
    },
    {
        "name": "/account-settings",
        "component": <UserSettings />
    },

    {
        "name": "/update_profile",
        "component": <UpdateProfile />
    },

    // {
    //     "name": "/profile",
    //     "component": <Profile />
    // },


    {
        "name": "/update-portfolio",
        "component": <PortfolioUpdate />
    },

    {
        "name": "/financial-dashboard",
        "component": <FinancialDashboard />
    },
    {
        "name": "/open-requests",
        "component": <OpenRequest />
    },
    {
        "name": "/support-ticket",
        "component": <NewRequestCS />
    },
    {
        "name": "/reply_messages_ticket/:id",
        "component": <ReplyTicket />
    }, {
        "name": "/view-profile/:id",
        "component": <ViewProfile />
    },
    {
        "name": "/messages",
        "component": <Messages />
    },
    {
        "name": "/chat-details/:id",
        "component": <ChatDetails />
    },
    {
        "name": "/add-members/:id",
        "component": <Addmembers />
    },
    {
        "name": "/single-showcase/:id",
        "component": <SingleShowcaseView />
    },
    {
        "name": "/project-detailed-view/:id",
        "component": <Hired />
    },
    {
        "name": "/disputes",
        "component": <DisputeFlow />
    },
    {
        "name": "/create-disputes",
        "component": <CreateDispute />
    },
    {
        "name": "/create-disputes/:id",
        "component": <CreateDispute />
    },
    // {
    //     "name": "/get-certifications",
    //     "component": <ExamList />
    // },
    {
        "name": "/exam/:id",
        "component": <ExamView />
    },
    {
        "name": "/my-hired",
        "component": <Myhire />
    },
    {
        "name": "/transaction-history",
        "component": <TransactionHistory />
    }, {
        "name": "/withdraw-funds",
        "component": <WithdrawFunds />
    }
    , {
        "name": "/my-active-projects",
        "component": <ActiveProjectsData />
    },
    {
        "name": "/pay-balance",
        "component": <PayBalance />
    },
    {
        "name": "/showcase-details/:id",
        "component": <ShowcaseDetails />
    },
    {
        "name": "/showcases-overview/:id",
        "component": <ShowcaseData />
    },
    {
        "name": "/showcase-reviews/:id",
        "component": <ShowReviews />
    },



];

